const reports = {
  dashboard: {
    title: 'Reports Dashboard',
  },
  errors: {
    noAccessToken: 'No Access Token',
    tokenUnavailable: 'Dashboard access token unavailable.',
  },
};

export const en = {
  reports,
};
